import { create } from 'zustand';
import { getLoyaltyPointsByCustomerId } from '../api/loyaltyPoints';
import { LoyaltyPoint } from '../common/types';


interface LoyaltyPointsState {
    loyaltyPoints: LoyaltyPoint[]
    loading: boolean;
    reset: () => void
    fetchLoyaltyPointsForCustomer: (customerId: number) => Promise<void>
    getAvailableBalance: () => number
}


const useLoyaltyPoints = create<LoyaltyPointsState>((set, get) => ({
    loyaltyPoints: [],
    loading: false,
    reset: () => set({ loyaltyPoints: [], loading: false }),
    fetchLoyaltyPointsForCustomer: async (customerId: number) => {
        if (get().loading) {
            return
        }
        set({ loading: true });
        try {
            const loyaltyPoints = await getLoyaltyPointsByCustomerId(customerId);
            set({ loyaltyPoints, });
        } catch (err) {
            console.error(err);
        } finally {
            set({ loading: false });
        }
    },
    getAvailableBalance: () => {
        const { loyaltyPoints } = get()
        let loyaltyPointsBalance = 0
        if (loyaltyPoints && loyaltyPoints.length > 0) {
            loyaltyPointsBalance = loyaltyPoints[0].closingBalance
        }

        return Math.max(0, loyaltyPointsBalance)
    },
}))

export default useLoyaltyPoints